import {useConstant, useToggle} from '@startlibs/core'
import _ from 'lodash/fp'
import {useState} from 'react'
import {useRecordStateManager, useUploader} from './index'
import {uploadQueue} from './queues'

export const RecordsManager = ({ children, getJwt, resolveJwt, disabled }) => {

  const [records, recordManager] = useRecordStateManager(() => [])

  const [data, setData] = useState({ isProcessing: 0 })
  
  const mode = useToggle({
    slowMode: false,
  })

  const uploader = useUploader(getJwt, uploadQueue, recordManager, mode.get)

  const doAction = useConstant(_.curry((action, value, ...rest) => {
    return action({ data, setData, getMode: mode.get, setMode: mode.openWith, recordManager, uploader, resolveJwt}, value, ...rest)
  }))

  return !disabled ? children(records, data, doAction) : null
}
